import { styled } from "styled-components";

export const ImageButton = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  background-color: #383838;
  color: #fff;
  border-radius: 20px;
  margin-top: 24px;
  padding: 12px 18px;
  cursor: pointer;
  font-size: 18px;

  svg {
    margin-right: 8px;
  }
`;
